module.exports = __webpack_public_path__ + "static/img/trebuchet2.bc5af39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/trebuchet2.png
// module id = V0A/
// module chunks = 0